// extracted by mini-css-extract-plugin
module.exports = {"img":"Mojo_img__2BhI4","imgWrapper":"Mojo_imgWrapper__3IkHI"};